import { GeneralStyle } from '@website-builder/model/style/general-style';

export class TextStyle extends GeneralStyle {
  textColumns = '';
  columnDividers = '';
  size = 'uk-h5';
  font = 'tb-font-primary';
  dropCap = '';

  static normalize(styles: Partial<TextStyle>): TextStyle {
    const generalStyles: GeneralStyle = GeneralStyle.normalize(styles);
    const pureStyles = new TextStyle();

    Object.assign(pureStyles, generalStyles);

    pureStyles.textColumns = styles.textColumns ?? pureStyles.textColumns;
    pureStyles.columnDividers = styles.columnDividers ?? pureStyles.columnDividers;
    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.dropCap = styles.dropCap ?? pureStyles.dropCap;

    return pureStyles;
  }
}
